<label class="title" for="generate-finding-select">
  {{ 'pipeline_step_editor.generate_finding.title' | translate }}
</label>
<p class="description">
  {{ 'pipeline_step_editor.generate_finding.description' | translate }}
</p>
<select
  id="generate-finding-select"
  class="ts-selector"
  [disabled]="disabled"
  (change)="onChange($event)"
>
  <option [value]="ON_ASSET_CREATED" [selected]="value === ON_ASSET_CREATED">
    {{ 'pipeline_step_editor.generate_finding.option_on_asset_created' | translate }}
  </option>
  <option [value]="ON_USER_CAPTURE" [selected]="value === ON_USER_CAPTURE">
    {{ 'pipeline_step_editor.generate_finding.option_on_user_capture' | translate }}
  </option>
  <option [value]="NEVER" [selected]="value === NEVER">
    {{ 'pipeline_step_editor.generate_finding.option_never' | translate }}
  </option>
</select>
